import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { CorporateSupportComponent } from './corporate-support.component';

const routes: Routes = [
    {
        path     : 'corporate-support',
        component: CorporateSupportComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
      CorporateSupportComponent,
    ],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class CorporateSupportModule { }


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/corporate-support/corporate-support.module.ts